<div class="p-3">
  <table class="table" id="payout-statements-table">
    <thead>
      <tr>
        <th>Dokumentnummer</th>
        <th>Ausgestellt am</th>
        <th>Auszahlung erwartet am</th>
        <th>Betrag</th>
        <th></th>
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let payoutStatement of payoutStatements">
        <td>{{ payoutStatement.documentNumber }}</td>
        <td>{{ payoutStatement.createdAt | dateDE }}</td>
        <td>{{ payoutStatement.paidAt | dateDE }}</td>
        <td>{{ payoutStatement.total | currency:'EUR' }}</td>
        <td><a (click)="download(payoutStatement)">
          <app-svg source="icons/feather/download" height="18" style="position: relative; top: -2px"></app-svg>
        </a></td>
      </tr>
      
      <tr *ngIf="payoutStatements.length < 1">
        <td colspan="4" class="h-100 py-3 text-center align-middle">
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg><br />
          <span class="pt-3">Keine Einträge vorhanden.</span>
        </td>
      </tr>
    </tbody>
  </table>
</div>